import React, { useState } from 'react';
import { Button, Card, Container, Modal } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';

import { useTranslation } from 'react-i18next';
import LanguageSelector from '../common/languageSelector';
import Cookies from 'js-cookie';
import { downloadQR } from '../../utils/downloadQr';
import { downloadCertificationCardPresentation } from '../../utils/downloadCertificationCardPresentation';
import { loadStampBasque, loadStampCatalan, loadStampEnglish, loadStampSpanish, loadStampItaliano } from '../../utils/stampBase64';


function DownloadCertificationsPopUp({ data, base64QR, show, handleClose, title, id, qrLink }) {

    const [t, i18n] = useTranslation("companies")
    const [companyLanguages, setCompanyLanguages] = useState(['es', 'ca', 'eu', 'en', 'it']);
    const [selectedLanguage, setSelectedLanguage] = useState(Cookies.get('myreportin_language'));





    const stamp = {
        es: loadStampSpanish(),
        ca: loadStampCatalan(),
        eu: loadStampBasque(),
        en: loadStampEnglish(),
        it: loadStampItaliano(),
    };
    const stampName = {
        es: 'sello-certificado-myreportin.png',
        ca: 'segell-certificat-myreportin.png',
        eu: 'selloa-egiaztatua-myreportin.png',
        en: 'certified-stamp-myreportin.png',
        it: 'certified-stamp-myreportin.png',
    };

    const responsibleStart = {
        es: 'https://www.myreportin.com/descargas/acreditacion-responsable_myreportin.pdf',
        ca: 'https://www.myreportin.com/baixades/acreditacio-responsable_myreportin.pdf',
        eu: 'https://www.myreportin.com/deskargak/akreditazio-arduradun_myreportin.pdf',
        en: 'https://www.myreportin.com/downloads/accreditation-responsible_myreportin.pdf',
        it: 'https://myreportin.com/download-it/attestazione-responsabile.pdf',
    };

    const responsibleFinish = {
        es: 'https://www.myreportin.com/descargas/acreditacion-cese_responsable_myreportin.pdf',
        ca: 'https://www.myreportin.com/baixades/acreditacio-cesament-responsable_myreportin.pdf',
        eu: 'https://www.myreportin.com/deskargak/akreditazio-utzi-arduradun_myreportin.pdf',
        en: 'https://www.myreportin.com/downloads/accreditation-cessation-responsible_myreportin.pdf',
        it: 'https://myreportin.com/download-it/attestazione-cessazione-responsabile.pdf',
    };

    const responsibleJoinBoth = {
        es: 'https://www.myreportin.com/descargas/acreditaciones-responsable_myreportin.pdf',
        ca: 'https://www.myreportin.com/baixades/acreditacions-responsable_myreportin.pdf',
        eu: 'https://www.myreportin.com/deskargak/akreditazioak-arduradun_myreportin.pdf',
        en: 'https://www.myreportin.com/downloads/accreditations-responsible_myreportin.pdf',
        it: 'https://myreportin.com/download-it/attestazione_responsabile_attestazione-cessazione-responsabile.pdf',
    };



    const DOWNLOADFUNCTIONS = {
        presentation: downloadPresentation,
        stamp: downloadStamp,
        qr: downloadQRcode,
        responsibleStart: downloadResponsibleStart,
        responsibleFinish: downloadResponsibleFinish,
        responsibles: downloadResponsibles,
    };


    function downloadPresentation() {
        i18n.changeLanguage(selectedLanguage)
        downloadCertificationCardPresentation(data, selectedLanguage, base64QR)
        let languageCookie = Cookies.get('myreportin_language');
        i18n.changeLanguage(languageCookie)
    }

    function downloadStamp() {
        let imageB64 = stamp[selectedLanguage];

        // Crear un elemento de enlace
        let downloadLink = document.createElement('a');
        downloadLink.href = imageB64;
        downloadLink.download = stampName[selectedLanguage];
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }




    function downloadQRcode() {
        downloadQR(qrLink)
    };

    function downloadResponsibleStart() {
        window.open(responsibleStart[selectedLanguage], '_blank');
    }

    function downloadResponsibleFinish() {
        window.open(responsibleFinish[selectedLanguage], '_blank');
    }

    function downloadResponsibles() {
        window.open(responsibleJoinBoth[selectedLanguage], '_blank');
    }

    const handleDownload = () => {
        const selectedFunction = DOWNLOADFUNCTIONS[id];
        handleClose()
        if (selectedFunction) {
            selectedFunction();
        }

    }

    const handleLanguageChange = (value) => {
        setSelectedLanguage(value.value)
    }

    return (
        <Modal show={show} onHide={handleClose} backdrop="static">
            <Modal.Body className="width-150">
                <Container>
                    <Card className="mx-auto p-3 rounded-border-px custom-shadow">
                        <Card.Body className="d-flex flex-column align-items-center">
                            <p className=" text-center modal-title mt-2 mb-3">{id !== 'responsibles' && t("certificationsDownloadPopUp.popUpTitle")} <span className='text-uppercase'>{title}</span></p>
                            <div className="text-center mt-auto w-100">
                                <Button
                                    variant="none"
                                    className="modal-close-button"
                                    onClick={handleClose}
                                >
                                    <FaTimes className="mb-1" />
                                </Button>

                                <span>{t("certificationsDownloadPopUp.popUpText")}</span>

                                <div className='mt-3'>
                                    <LanguageSelector onChange={handleLanguageChange} grayBackground={true} availableLanguages={companyLanguages} />
                                </div>

                                <div className='d-flex'>
                                    <Button
                                        type="none"
                                        className=" mx-auto mt-5 custom-button-secondary text-uppercase"
                                        onClick={handleClose}
                                    >
                                        {t("certificationsDownloadPopUp.cancel")}
                                    </Button>
                                    <Button
                                        type="submit"
                                        className=" mx-auto mt-5 custom-button-primary custom-bg-primary text-uppercase"
                                        onClick={handleDownload}
                                    >
                                        {t("certificationsDownloadPopUp.download")}
                                    </Button>
                                </div>

                            </div>
                        </Card.Body>
                    </Card>
                </Container>
            </Modal.Body>
        </Modal>
    );
}

export default DownloadCertificationsPopUp;